var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "docs",
    [
      _vm.doc
        ? [
            _c("markdown", { attrs: { markdown: _vm.doc.content } }),
            _vm.doc.data.source
              ? _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://github.com/stefanwimmer128/core/blob/master/src/" +
                        _vm.doc.data.source,
                      target: "_blank"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { plain: "plain", type: "primary" } },
                      [_vm._v(_vm._s(_vm.doc.data.source))]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        : [
            _c("h1", [_vm._v("Error 404 Not Found")]),
            _c("p", [
              _vm._v(
                'Documentation for "' +
                  _vm._s(this.$route.params.doc) +
                  '" not found!'
              )
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fb65e44", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb65e44","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Doc.vue
// module id = 749
// module chunks = 0